module.exports = __webpack_public_path__ + "static/media/mira_search_principle.74b966dc.png";